<template lang="pug">
  .layout
    v-layout.my-6(v-if="isFetching")
      v-row.fill-height.ma-0(align='center' justify='center')
        v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
    v-card-text.pa-0(v-else)

      div.page-break.pa-8
        div.d-flex
          .h5.font-weight-regular.mt-auto {{ $t('pick_list') }}
          v-spacer
          div.text-end
            .p2.basic600--text {{ companyName }}
            .p2.basic600--text 
              span.mr-2 {{ $t('generated') }}: {{ new Date().toISOString() | convertServerDateWithZone(timezone) }}
              span {{ $t('orders') }}: {{ orderCount }}

        .products.mt-6
          .header
            v-row(no-gutters)
              v-col.shrink.py-2
                div(style="width: 80px")
                  div.c2.basic700--text.pl-2 #
              v-col.py-2
                v-row(no-gutters)
                  v-col.pa-0
                    div.c2.basic700--text {{ $t('product') }}
                  v-col.pa-0.shrink
                    div.d-flex.align-center.mr-4(style="width: 100px;")
                      div.c2.basic700--text {{ $t('variant') }}
                  v-col.pa-0.shrink
                    div.d-flex.align-center(style="width: 100px;")
                      div.c2.basic700--text {{ $t('qty') }}
                      v-spacer
                      div.c2.basic700--text {{ $t('order_id') }}
            
          v-divider.basic600

          .content
            template(v-for="(pick, idx) in pickList")
              v-row(no-gutters :key="pick+idx")
                v-col.shrink.py-3
                  div.d-flex.align-center.justify-center(style="width: 80px")
                    div.p2.primary500--text.mb-auto {{ idx+1 }}
                    div.ml-3
                      v-img(:src="pick.image ? `https://img.yezza.io/100x100/${pick.image.path}` : require('@/assets/image_placeholder.png')" max-width="40px" width="40px" height="40px" eager)
                
                v-col.py-2(v-if="pick.variants.length === 0")
                  v-row(no-gutters)
                    v-col.pa-0
                      div.d-flex.align-center
                        div.mb-auto.pb-2
                          .p2.primary--text {{ pick.name }}
                          template(v-for="product in pick.add_ons")
                            div.d-flex.align-center
                              div.c1.basic700--text.mt-2.mb-auto + {{ product.name }} {{ product.total_quantity > 1 ? ' x ' + product.total_quantity : '' }}
                    v-col.pa-0.shrink
                      div.d-flex.align-center.mr-4(style="width: 100px;")
                    v-col.pa-0.shrink
                      div.d-flex.text-center(style="width: 100px;")
                        div.p2.basic600--text.pl-2 {{ pick.total_quantity }}
                        v-spacer
                        v-col.pa-0
                          template(v-for="rid in pick.lead_rids")
                            div.p2.basic600--text.mb-1 {{ '#' + rid }}
                
                v-col.py-2(v-else)
                  template(v-for="(product, index) in pick.variants")
                    v-divider.basic300.mb-2(v-if="index != 0")
                    v-row(no-gutters :key="product.id")
                      v-col.pa-0
                        div.d-flex.align-center
                          div.mb-auto.pb-2
                            .p2.primary--text(v-if="index == 0") {{ pick.name }}
                      v-col.pa-0.shrink
                        div.d-flex.align-center.mr-4(style="width: 100px;")
                          div.p2.basic600--text.pl-2 {{ product.name }}
                      v-col.pa-0.shrink
                        div.d-flex.text-center(style="width: 100px;")
                          div.p2.basic600--text.pl-2 {{ product.total_quantity }}
                          v-spacer
                          v-col.pa-0
                            template(v-for="rid in product.lead_rids")
                              div.p2.basic600--text.mb-1 {{ '#' + rid }}

              v-divider.basic500(v-if="idx+1 !== pickList.length")

          v-divider.basic600.mt-2

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PickList',
  props: ['pid'],
  data: () => ({
    isFetching: false,
    companyId: '',
    companyName: '',
    otk: '',
    orderCount: 0,
    pickList: [],
    timezone: 'Asia/Kuala_Lumpur'
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    isPrinting () {
      if (this.$route.path.includes('print-pick-list')) {
        return true
      }
      return false
    }
  },
  mounted () {
    if (this.isPrinting) {
      const data = JSON.parse(atob(this.pid))
      this.companyId = data.company_id
      this.companyName = data.company_name
      this.otk = data.key
      this.orderCount = data.leadPids.length
      this.fetchPickList(data.leadPids.join())
    } else {
      this.companyId = this.company.id
      this.companyName = this.company.name
      const ids = [3308,3252,3220,3218,3217,3211,3207,3204,3202,3200,3193,3184,3181,3128,3127,3125,3123,3121,3119,3118]
      this.orderCount = ids.length
      this.fetchPickList(ids.join())
    }
    this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  },
  methods: {
    fetchPickList(leadPids) {
      this.isFetching = true
      let url = `/leads/pick_list?company=${this.companyId}&lead_ids=${leadPids}&key=${this.otk}`
      this.$axios.get(url)
        .then((response) => {
          this.pickList = response.data
          this.isFetching = false
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.page-break {
  page-break-after: always;
}
</style>

<i18n>
{
  "en": {
    "pick_list": "Pick list",
    "generated": "Generated",
    "orders": "Orders",
    "variant": "Variant"
  },
  "id": {
    "pick_list": "Daftar pesanan",
    "generated": "Terhasil",
    "orders": "Order",
    "variant": "Varian"
  }
}
</i18n>
